import styled, { css } from 'styled-components'

interface PopoverProps {
  isOpen: boolean
  svgFilled?: boolean
  active: boolean
  position: 'left' | 'right' | 'center'
}

export const LeftPosition = css`
  left: 0;
  top: calc(100% + 5px);
`

export const RightPosition = css`
  right: 0;
  top: 0;
`

export const CenterPosition = css`
  top: calc(100% + 5px);
  left: 50%;
  transform: translateX(-50%);
`

export const PopoverContainer = styled.div<PopoverProps>`
  position: relative;

  .popover-button {
    position: relative;
    width: 2rem;
    height: 2rem;

    background: ${({ theme }) => theme.zds.colors.neutral1000};
    border: 1px solid ${props => (props.active ? props.theme.colors.color1f6ecd : props.theme.colors.colordfe3e8)};
    border-radius: 4px;
    cursor: pointer;

    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.15s ease-in-out;
    svg {
      ${props =>
        props.svgFilled
          ? css`
              fill: ${props.active ? props.theme.colors.color1f6ecd : props.theme.colors.colora7abb2};
            `
          : css`
              stroke: ${props.active ? props.theme.colors.color1f6ecd : props.theme.colors.colora7abb2};
            `}
      width: 100%;
      transition: all 0.15s ease-in-out;
    }

    &:hover svg {
      ${props =>
        props.svgFilled
          ? css`
              fill: ${props.active ? props.theme.colors.color1f6ecd : props.theme.colors.color545e6c};
            `
          : css`
              stroke: ${props.active ? props.theme.colors.color1f6ecd : props.theme.colors.color545e6c};
            `}
    }
  }

  .popover-content {
    position: absolute;
    transition: all 0.2s ease-in-out;

    ${props => {
      switch (props.position) {
        case 'left':
          return LeftPosition
        case 'right':
          return RightPosition
        case 'center':
        default:
          return CenterPosition
      }
    }}

    ${props =>
      props.isOpen
        ? css`
            visibility: visible;
            opacity: 1;
            z-index: 9999;
          `
        : css`
            visibility: hidden;
            opacity: 0;
            z-index: -1;
          `}
  }
`
